export const firestoreEnvironment =
    {
        production: false,
        
        firestore_config: 
            {
                apiKey: "AIzaSyDXP7eW--Hq-7TLA_t4evfg2-_PvgxO8fE",
                authDomain: "eventplan-58adb.firebaseapp.com",
                databaseURL: "https://eventplan-58adb.firebaseio.com",
                projectId: "eventplan-58adb",
                storageBucket: "eventplan-58adb.appspot.com",
                messagingSenderId: "731592615157",
                appId: "1:731592615157:web:90f6e55c39a5579f20d1bc"
            }
        
    };